import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-news-popup',
    templateUrl: './news-popup.component.html',
    styleUrls: ['./news-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NewsPopupComponent {
  @Input() visible: boolean = false;
  @Input() disabled: boolean = false;

  @Input() headline: string = '';
  @Input() description: string = '';
  @Input() linkUrl: string = '';
  @Input() linkButtonLabel: string = '';
  @Input() mediaUrl: string = '';
  @Input() mediaAltText: string = '';

  @Output() closed = new EventEmitter<void>();
  @Output() stopShowing = new EventEmitter<string>();
}
